import { render } from "./Testmo-exStd-labs.vue?vue&type=template&id=f793b92c&scoped=true"
import script from "./Testmo-exStd-labs.vue?vue&type=script&lang=js"
export * from "./Testmo-exStd-labs.vue?vue&type=script&lang=js"

import "./Testmo-exStd-labs.vue?vue&type=style&index=0&id=f793b92c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f793b92c"

export default script